import { appBaseUrl } from "@/variables"

import { CatalogClient } from "@/lib/api"


const initialState = () => ({
    api: new CatalogClient(appBaseUrl),
    categories: [],
    pagedItems: {},
    searchCompleted: {},
    destinationItem: {},
    homeBanner: {},
    homePageItems: [],
    currentCategory: { description: { arabic: "" } },
    currentCategoryOutlineId: "",
    allCategories:[],
    helpRequestForms:[],
    currentHelpRequestForm:{},
    currentPrivateHelpRequestForm:{},
    itemDetail:{},
    dedicationDesigns:[]
    
});

// State object
const state = {
    api: new CatalogClient(appBaseUrl),
    categories: [],
    categoriesMenuItems:[],
    pagedItems: {},
    searchResult: {},
    destinationItem: {},
    homeBanner: {},
    homePageItems: [],
    currentCategory: { description: { arabic: "" } },
    currentCategoryOutlineId: "",
    allCategories:[],
    helpRequestForms:[],
    currentHelpRequestForm:{},
    currentPrivateHelpRequestForm:{},
    itemDetail:{},
    dedicationDesigns:[]
}

// Getter functions
const getters = {
    getApi(state) {
        return state.api;
    },
    categories(state) {
        return state.categories;
    },
    categoriesMenuItems(state){
        return state.categoriesMenuItems;
    },
    pagedItems(state) {
        return state.pagedItems;
    },
    searchResult(state) {
        return state.searchResult;
    },
    destinationItem(state) {
        return state.destinationItem;
    },
    homeBanner(state) {
        return state.homeBanner;
    },
    homePageItems(state) {
        return state.homePageItems;
    },
    currentCategory(state){
        return state.currentCategory;
    },
    helpRequestForms(state){
        return state.helpRequestForms;
    },
    currentHelpRequestForm(state){
        return state.currentHelpRequestForm;
    },
    itemDetail(state){
        return state.itemDetail;
    },
    currentPrivateHelpRequestForm(state){
        return state.currentPrivateHelpRequestForm;
    }
    ,
    dedicationDesigns(state){
        return state.dedicationDesigns;
    }
    
}

// Actions 
const actions = {
    async loadCategories({commit, state}){

        const response = await state.api.categories();
        commit('loadCategoriesCompleted', response);

        let outlineId = state.currentCategoryOutlineId;
        
        let result = state.categories.filter(x => x.outlineId === outlineId);

        if(result.length > 0){
            commit('loadCurrentCategoryCompleted', result[0]);
        }else {
            commit('loadCurrentCategoryCompleted', {imageUrl: {english:'', arabic:''}});
        }

    },

    async loadAllCategories({commit, state}){

        const response = await state.api.allCategories();
        commit('loadAllCategoriesCompleted', response);

        let outlineId = state.currentCategoryOutlineId;
        
        let result = state.categories.filter(x => x.outlineId === outlineId);

        if(result.length > 0){
            commit('loadCurrentCategoryCompleted', result[0]);
        }else {
            commit('loadCurrentCategoryCompleted', {imageUrl: {english:'', arabic:''}});
        }

    },

    async loadPagedItems({commit, state}, {categoryOutlineId , page, pageSize, sortBy}) {

        let model = {
            categoryOutlineId : categoryOutlineId,
            page : page,
            pageSize : pageSize,
            sortBy: sortBy
        }

        const response = await state.api.pagedItems(model);

        commit('loadPagedItemsCompleted', response);

    },

    async loadDestinationItem({commit, state}, itemId) {

        const response = await state.api.getItem(itemId);

        commit('loadDestinationItemCompleted', response);

    },

    async search({commit, state}, {searchText , page, pageSize, sortBy}) {

        let model = {
            searchText : searchText,
            page : page,
            pageSize : pageSize,
            sortBy: sortBy
        }

        const response = await state.api.search(model);

        commit('searchCompleted', response);

    },

    async loadHomeBanner({commit, state}) {

        const response = await state.api.homeBanner();

        commit('loadHomeBannerCompleted', response);

    },
    

    async loadHomePageItems({commit, state}) {

        const response = await state.api.homePageItems();

        commit('loadHomePageItemsCompleted', response);

    },

    loadCurrentCategory({commit, state}, outlineId){

        state.currentCategoryOutlineId = outlineId;

        let result = state.allCategories.filter(x => x.outlineId === outlineId);

        if(result.length > 0){
            commit('loadCurrentCategoryCompleted', result[0]);
        }else {
            commit('loadCurrentCategoryCompleted', {description: {arabic:''} , imageUrl: {english:'', arabic:''}});
        }
        
    },

    async loadHelpRequestForms({commit, state}){
        const response = await state.api.helpRequestForms();
        commit('loadHelpRequestFormsCompleted', response);
    },

    async loadHelpRequestForm({commit, state}, formId){
        
        let result = state.helpRequestForms.filter(x => x.id === formId);

        if(result.length > 0){
            commit('loadHelpRequestFormCompleted', result[0]);
        }else {
            commit('loadHelpRequestFormCompleted', {});
        }

    },

    async loadCurrentHelpRequestForm({commit, state}, formId){
        
        const response = await state.api.helpRequestFormById(formId);

        commit('loadCurrentHelpRequestFormCompleted', response);

    },

    async loadCurrentPrivateHelpRequestForm({commit, state}, {formId, key}){
        
        const response = await state.api.privateHelpRequestFormById(formId,key);

        commit('loadCurrentPrivateHelpRequestFormCompleted', response);

    },

    async loadItemDetail({commit, state}, itemId){
        const response = await state.api.getItem(itemId);

        commit('loadItemDetailCompleted', response);
    },

    async loadDedicationDesigns({commit, state}){
        const response = await state.api.dedicationDesigns();

        commit('loadDedicationDesignsCompleted', response);
    }
    
}

// Mutations
const mutations = {

    loadCategoriesCompleted(state, categories){
        state.categories = categories;
    },

    loadAllCategoriesCompleted(state, allCategories){
        state.categories = allCategories.categoryTree;
        state.allCategories = allCategories.flatCategories;
    },
    loadPagedItemsCompleted(state, pagedItems){
        state.pagedItems = pagedItems;
    },

    loadDestinationItemCompleted(state, destinationItem){
        state.destinationItem = destinationItem;
    },

    searchCompleted(state, searchResult){
        state.searchResult = searchResult;
    },

    loadHomeBannerCompleted(state, banner){
        state.homeBanner = banner;
    },

    loadHomePageItemsCompleted(state, items){
        state.homePageItems = items;
    },
    loadCurrentCategoryCompleted(state, category){
        state.currentCategory = category;
    },

    loadHelpRequestFormsCompleted(state, forms){
        state.helpRequestForms = forms;
    },

    loadHelpRequestFormCompleted(state, form){
        state.currentHelpRequestForm = form;
    },

    loadCurrentHelpRequestFormCompleted(state, form){
        state.currentHelpRequestForm = form;
    },

    loadCurrentPrivateHelpRequestFormCompleted(state, form){
        state.currentPrivateHelpRequestForm = form;
    },

    loadItemDetailCompleted(state, item){
        state.itemDetail = item;
    },

    loadDedicationDesignsCompleted(state, dedicationDesigns){
        state.dedicationDesigns = dedicationDesigns;
    },

    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },
    loadToken(state){
        let token = window.localStorage.getItem('token') || ""
        state.api.instance.defaults.headers.common = {'Authorization': `Bearer ${token}`};
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}